<div class="header__overlay-links">
  <button type="button" role="link" class="disp-block text-left reset-btn header__overlay-link" (click)="toSettingsEvent.emit()">
    {{ 'header.overlay.to_settings' | translate }}
  </button>
  <button class="disp-block text-left reset-btn header__overlay-link" type="button" (click)="openLogoutEvent.emit()">
    {{ 'header.overlay.logout' | translate }}
  </button>
</div>
